import axios from 'axios';

export type DeleteDesignPackageParams = {
	packageId: string;
	getAccessTokenSilently: () => Promise<string>;
};

export type DeleteDesignPackageResult = {
	packageId: string;
	deletedAt: string;
};

// Revokes every share link immediately and hides the package from listings; the blobs themselves are
// purged later by a nightly sweep, so this is recoverable for a short grace window, not gone outright.
// Idempotent on the server: deleting an already-deleted package still answers 200 with its original
// deletedAt, so a 404 here only ever means the id was never a real package.
export const deleteDesignPackage = async (params: DeleteDesignPackageParams): Promise<[DeleteDesignPackageResult | null, string | null]> => {
	const { packageId, getAccessTokenSilently } = params;

	try {
		const token = await getAccessTokenSilently();
		const apiUrl = import.meta.env.VITE_API_URL;
		const response = await axios.delete<DeleteDesignPackageResult>(`${apiUrl}/design-packages/${packageId}`, {
			headers: { Authorization: `Bearer ${token}` }
		});
		return [response.data, null];
	} catch {
		return [null, 'Failed to delete design package'];
	}
};
